import {set, clear} from "./sessionActionsCreator";

export function setProject(project) {
	return dispatch => {
		dispatch(set("project", project));
	}
}

export function clearSession() {
	return clear();
}
